<template>
<div class="wrapper">
  <div v-if="!loading">
      <div>
        <CButton class="col-3 mt-3 " variant="outline" color="info">
          <download-excel
            :data="json_data_transform"
            :fields="json_fields"
            :name= "filename"
          >
            Download Excel
          </download-excel>
        </CButton>
        <div style="width: 500px">
          <label>Filter Question</label>
          <b-form-select v-model="formfield_choose" :options="formfield_option"></b-form-select>
        </div>

      </div>
      <br>
      <div class="panel-body" id="print">
        <!-- <h3>Icare Report</h3>
        <h6>Period: {{ period }}</h6> -->
        <br>
        <table class="table" style="width:auto">
          <thead>
            <tr>
              <th style="width: 8px;">#</th>
              <th style="width: 150px;">Name</th>
              <th style="width: 150px;">Email</th>
              <th style="width: 800px;">Data</th>
              <th style="width: 150px;">Qty Ticket</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dt, index) in rpt" :key="index">
              <td>{{ index+1 }}</td>
              <td>{{ dt.name }}</td>
              <td>{{ dt.email }}</td>
              <td>
                <table v-if="formfield_choose != 0">
                  <thead>
                    <th style="width: 400px;">Question</th>
                    <th style="width: 400px;">Answer</th>
                  </thead>
                    <tr v-for="(dtx, index) in dt.form_field" :key="index">
                      <!-- <td v-if="formfield_choose == index+1">{{ index+1 }}</td> -->
                      <td v-if="formfield_choose == index+1">{{ dtx.label }}</td>
                      <td v-if="formfield_choose == index+1">{{ dtx.value }}</td>
                    </tr>
                </table>
                <table v-else>
                  <thead>
                    <th style="width: 400px;">Question</th>
                    <th style="width: 400px;">Answer</th>
                  </thead>
                    <tr v-for="(dtx, index) in dt.form_field" :key="index">
                      <!-- <td v-if="formfield_choose == index+1">{{ index+1 }}</td> -->
                      <td>{{ dtx.label }}</td>
                      <td>{{ dtx.value }}</td>
                    </tr>
                </table>
              </td>
              <td>{{ dt.order_details[0].qty }}</td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
  <div v-else class="d-flex content-center min-vh-100">
      <b-spinner variant="primary" label="Spinning"><br></b-spinner>
  </div>

<!-- <pre>{{ $data }}</pre> -->
</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import report from '@/services/report';
import event from '@/services/event';

import Vue from "vue";
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

export default {

    data(){
        return{
          rpt:'',
          period:'',
          loading: false,
          filename: "a.xls",
          json_fields: {
              "Name": "name",
              "Email": "email",
              "Data": "form_field"
          },
          json_data: [],
          json_data_transform: [],
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
          formfield_option: [],
          formfield_choose: '0'
        }
    },
    created(){
      this.loadData()
    },
    mounted() {

    },

    methods: {
      loadData(){
        // var params = {
        //   month: this.$route.query.month,
        //   year: this.$route.query.year
        // }
        this.loading = true
        // report.getIcareReportMonth(params)
        // .then(res => {
        //     let getData = res.data
        //     this.period = res.periodMonth + ' ' + res.periodYear
        //     this.filename = "Icare Report " + this.period
        //     this.rpt = getData
        //     this.json_data = getData
        //     this.loading = false
        // }).catch ((err) => {
        //   alert(err.response.data.message)
        // })
        event.getFormFieldData(this.$route.query.id)
        .then(res => {
            let getData = res.data
            //this.formfield_option = res.formfield
              this.formfield_option.push({text: 'all', value: '0'})
              for (let i=0; i <= res.formfield.length-1; i++){
                this.formfield_option.push({text: res.formfield[i].label, value: i+1})
              }
            // this.period = res.periodMonth + ' ' + res.periodYear
            this.filename = "Event Report Attendance " + this.$route.query.name + " " + this.$route.query.date
            this.rpt = getData
            this.json_data = getData
            this.json_data_transform = this.transformJSON(this.json_data);
            this.loading = false
        }).catch ((err) => {
          alert(err.response.data.message)
        })

      },
      transformJSON(jsonData) {
        let transformedData = [];

        jsonData.forEach(data => {
          let transformedObj = {
            name: data.name,
            email: data.email,
            form_field: ''
          };

          data.form_field.forEach(field => {
            let value = field.value || '-';
            transformedObj.form_field += `${field.label} : ${value} <br>`;

            // separate all on field data into each column
            transformedObj[`${field.label.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')}`] = `${value}`;
            this.json_fields[`${field.label}`] = `${field.label.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')}`;

          });

          transformedObj['qty_ticket'] = data.order_details[0].qty
          this.json_fields['Qty Ticket'] = 'qty_ticket';

          transformedData.push(transformedObj);
        });

        return transformedData;
      }


    }
}
</script>
